import { transformUnits } from "./pdf_state";

const ivCtxFontSizeRatio = (sz, pdf = false) => {
  if (!sz) {
    return null;
  }
  if (pdf === true) {
    return 1 * sz;
  }
  //   if (pdf === true) return 0.75 * 0.75 * sz;
};

export const TITLE_JKPDF = {
  fontSize: ivCtxFontSizeRatio(14, true),
  fontWeight: 500,
  textColor: "#333",
  fillColor: "#fff",
  minCellHeight: transformUnits(ivCtxFontSizeRatio(160, true)),
};
